/**
 * @license
 * @copyright Copyright Motili Inc., 2026 All Rights Reserved
 */

import emptyApi from 'common/stores/redux/baseApi';
import { alertOnError } from 'common/stores/redux/utils';
import { fetchSavedAgreementTemplates } from 'admin/services/AdminContractorRegistrationService';

export interface AgreementTemplate {
    displayName: string;
    templateId: string;
}

export enum AgreementTemplateType {
    DataConsentForm = 'dataConsentForm',
    RecurringPaymentAuthorization = 'recurringPaymentAuthorization',
    ContractorNetworkAgreement = 'contractorNetworkAgreement',
    ContractorExpectationsAcknowledgment = 'contractorExpectationsAcknowledgment',
    CompanyMSA = 'companyMSA',
}

export type SavedAgreementTemplates = {
    [AgreementTemplateType.DataConsentForm]: AgreementTemplate;
    [AgreementTemplateType.RecurringPaymentAuthorization]: AgreementTemplate;
    [AgreementTemplateType.ContractorNetworkAgreement]: AgreementTemplate;
    [AgreementTemplateType.ContractorExpectationsAcknowledgment]: AgreementTemplate;
    [AgreementTemplateType.CompanyMSA]: AgreementTemplate;
};

const apiWithTag = emptyApi.enhanceEndpoints({
    addTagTypes: ['savedAgreementTemplates'],
});

const api = apiWithTag.injectEndpoints({
    endpoints: build => ({
        getSavedAgreementTemplates: build.query<SavedAgreementTemplates, void>({
            queryFn: async () => {
                const data = await fetchSavedAgreementTemplates();
                return { data };
            },
            onQueryStarted: alertOnError(
                'An error occurred fetching the saved agreement templates. Please refresh the page to try again.'
            ),
            providesTags: ['savedAgreementTemplates'],
        }),
    }),
});

export const { useGetSavedAgreementTemplatesQuery } = api;
